import { useMutation } from 'react-query';
import { useCallback } from 'react';
import { publicAxios } from '../api/api';

export function usePasswordTokenValidation() {
  const validateToken = useCallback(async (token) => {
    const response = await publicAxios.post('/validate-password-token', { token });
    return response.data;
  }, []);

  const { mutateAsync, isLoading } = useMutation(validateToken);

  return {
    validateToken: mutateAsync,
    isLoading: isLoading
  };
}
